import { Button, CircularProgress, Grid, Typography } from "@mui/material"
import OneModal from "../../../../Components/OneModal/OneModal"
import { useContext, useEffect, useState } from "react"
import { WebSocketContext } from "../../../../Providers/WebSocket/WebSocketContext"
import { CondominiosContext } from "../../../../Providers/CondominiosContext/CondominiosContext"
import { UserContext } from "../../../../Providers/UserContext/UserContex"
import { OneSwitch } from "../../../../Components/OneSwitch/OneSwitch"
import OneDatePicker from "../../../../Components/OneDatePicker/OneDatePicker"
import moment from "moment"
import AutocompletePessoa from "../../../../Components/AutocompletePessoa/AutocompletePessoa"
import { formatDate, showNotify } from "../../../../Utils/Utils"
import HorariosSemana from "../../../../Components/OneHorarioPersonalizado/OneHorarioPersonalizado"

const ModalAutorizados = ({ openModal, setOpenModal, id = false, setIdAutorizacao, cd_acesso_visitante }) => {
    const { sendWs, addRoute } = useContext(WebSocketContext)
    const [loading, setLoading] = useState(true)
    const { activeCond } = useContext(CondominiosContext)
    const { user } = useContext(UserContext)

    const [initialData, setInitialData] = useState()

    const diasPadrao = [
        { nome: "Domingo", key: "domingo" },
        { nome: "Segunda", key: "segunda" },
        { nome: "Terça", key: "terca" },
        { nome: "Quarta", key: "quarta" },
        { nome: "Quinta", key: "quinta" },
        { nome: "Sexta", key: "sexta" },
        { nome: "Sábado", key: "sabado" }
    ]

    const [formData, setFormData] = useState({})

    const getInitialData = (msg) => {
        if (msg.data.status) {
            msg.data.autorizacao[0].dt_inicial = formatDate(msg.data.autorizacao[0].dt_inicial, 'yyyy-MM-DD')
            msg.data.autorizacao[0].dt_final = formatDate(msg.data.autorizacao[0].dt_final, 'yyyy-MM-DD')

            if (msg.data.autorizacao[0].personalizado == 1 && msg.data.autorizacao[0].dias_semana) {
                const diasAtivos = msg.data.autorizacao[0].dias_semana.substring(1)

                if (diasAtivos.includes('1')) {
                    const hr_person_regras = JSON.parse(msg.data.autorizacao[0].hr_person_regras)

                    msg.data.autorizacao[0].horarios_semana = diasPadrao.map((dia, index) => {
                        const diaNumero = (index + 1).toString()
                        const horarioDia = hr_person_regras[diaNumero]

                        return {
                            ...dia,
                            ativo: diasAtivos[index] === '1',
                            inicio: horarioDia?.ini1 || '',
                            fim: horarioDia?.fim1 || '',
                            ...(diasAtivos[index] === '1' && horarioDia.ini2 ? { ini2: horarioDia.ini2 || '' } : ''),
                            ...(diasAtivos[index] === '1' && horarioDia.fim2 ? { fim2: horarioDia.fim2 || '' } : '')
                        }
                    })
                }
            }
            setInitialData({
                ...msg.data.autorizacao[0],
                id_central: activeCond.id_central,
                id_usuario: user.id,
                cd_acesso_morador: msg.data.autorizacao[0].cd_acesso_morador,
                cd_acesso_visitante: msg.data.autorizacao[0].cd_acesso_visitante,
                id_imovel_morador: msg.data.autorizacao[0].id_imovel_morador,
                morador: msg.data.autorizacao[0].morador,
                personalizado: msg.data.autorizacao[0].personalizado == 1,
                horarios_semana: msg.data.autorizacao[0].horarios_semana || diasPadrao.map((dia) => ({
                    ...dia,
                    ativo: true,
                    inicio: "",
                    fim: ""
                }))
            })
            setFormData({
                ...msg.data.autorizacao[0],
                id_central: activeCond.id_central,
                id_usuario: user.id,
                cd_acesso_morador: msg.data.autorizacao[0].cd_acesso_morador,
                cd_acesso_visitante: msg.data.autorizacao[0].cd_acesso_visitante,
                id_imovel_morador: msg.data.autorizacao[0].id_imovel_morador,
                morador: msg.data.autorizacao[0].morador,
                personalizado: msg.data.autorizacao[0].personalizado == 1,
                horarios_semana: msg.data.autorizacao[0].horarios_semana || diasPadrao.map((dia) => ({
                    ...dia,
                    ativo: true,
                    inicio: "",
                    fim: ""
                }))
            })
            setLoading(false)
        } else {
            setLoading(false)
        }
    }

    useEffect(() => {
        if (id) {
            addRoute('buscarAutorizacaoByID', getInitialData)
            sendWs('buscarAutorizacaoByID', { id })
        } else {
            setInitialData({
                id_central: activeCond.id_central,
                id_usuario: user.id,
                cd_acesso_visitante,
                dt_inicial: moment().utc().startOf('day').format('yyyy-MM-DD'),
                dt_final: moment().utc().startOf('day').format('yyyy-MM-DD'),
                notificar_morador: 1,
                personalizado: 1,
                pre_autorizacao: 1,
                id_imovel_morador: ""
            })
            setFormData({
                id_central: activeCond.id_central,
                id_usuario: user.id,
                cd_acesso_visitante,
                dt_inicial: moment().utc().startOf('day').format('yyyy-MM-DD'),
                dt_final: moment().utc().startOf('day').format('yyyy-MM-DD'),
                notificar_morador: 1,
                personalizado: 1,
                pre_autorizacao: 1,
                id_imovel_morador: "",
                horarios_semana: diasPadrao.map((dia) => ({
                    ...dia,
                    ativo: true,
                    inicio: "",
                    fim: ""
                }))
            })
            setLoading(false)
        }
    }, [])

    const handleChange = (event) => {
        setFormData({ ...formData, [event.target.name]: event.target.value })
    }

    const handleChangeSwitch = (event) => {
        setFormData({ ...formData, [event.target.name]: event.target.checked })
    }

    const getResponseAutorizacao = (msg) => {
        if (msg.data.status == true) {
            setIdAutorizacao(null)
            setOpenModal(false)
            showNotify('success', 'Autorização salva com sucesso!')
            sendWs('buscarAutorizadosPorVisitante', { cd_acesso: cd_acesso_visitante, id_central: activeCond.id_central })
        } else {
            showNotify('error', msg.message)
        }
    }

    const handleSubmit = (event) => {
        event.preventDefault()
        addRoute('criarEditarAutorizacao', getResponseAutorizacao)

        if (formData.dt_inicial > formData.dt_final) {
            showNotify('error', 'A data inicial não pode ser maior que a data final!')
            return
        }

        if (!formData.cd_acesso_morador) {
            showNotify('error', 'Morador não selecionado!')
            return
        }

        if (!formData.dt_inicial || !formData.dt_final) {
            showNotify('error', 'Data inicial e data final não podem ser vazias!')
            return
        }

        if (formData.personalizado) {
            if (formData.horarios_semana.filter((horario) => horario.ativo).length === 0) {
                showNotify('error', 'Pelo menos um horário deve estar ativo!')
                return
            }

            for (const dia of formData.horarios_semana) {
                if (!dia.ativo) continue

                const inicioStr = dia.inicio != null ? String(dia.inicio).trim() : ''
                const fimStr = dia.fim != null ? String(dia.fim).trim() : ''
                const ini2Str = dia.ini2 != null ? String(dia.ini2).trim() : ''
                const fim2Str = dia.fim2 != null ? String(dia.fim2).trim() : ''

                if ((inicioStr && !fimStr) || (!inicioStr && fimStr)) {
                    showNotify('error', `Horário incompleto para ${dia.nome}: preencha Início e Fim!`)
                    return
                }

                if (inicioStr && fimStr && inicioStr >= fimStr) {
                    showNotify('error', `Horário inválido para ${dia.nome}: Início não deve ser maior que o Fim!`)
                    return
                }

                if ((ini2Str && !fim2Str) || (!ini2Str && fim2Str)) {
                    showNotify('error', `Segundo horário incompleto para ${dia.nome}: preencha Início e Fim!`)
                    return
                }

                if (ini2Str && fim2Str && ini2Str >= fim2Str) {
                    showNotify('error', `Segundo horário inválido para ${dia.nome}: Início não deve ser maior que o Fim!`)
                    return
                }
            }
        }

        let finalData = {
            id_central: formData.id_central,
            cd_acesso_morador: formData.cd_acesso_morador,
            id_imovel_morador: formData.id_imovel_morador,
            cd_acesso_visitante: formData.cd_acesso_visitante,
            dt_inicial: formData.dt_inicial,
            dt_final: formData.dt_final,
            notificar_morador: formData.notificar_morador ? 1 : 0,
            personalizado: formData.personalizado ? 1 : 0,
            pre_autorizacao: formData.pre_autorizacao ? 1 : 0
        }

        if (formData.personalizado && formData.horarios_semana) {
            // Criar string dias_semana no formato '1XXXXXXX' (primeiro 1 fixo + domingo até sábado)
            const dias_semana = '1' + formData.horarios_semana
                .map(dia => dia.ativo ? '1' : '0')
                .join('')

            finalData.dias_semana = dias_semana

            // Criar hr_person_regras como JSON: {"1":{"ini1":"00:00","fim1":"23:59"}, ...}
            // Onde 1=Domingo, 2=Segunda, ..., 7=Sábado
            const hr_person_regras = {}
            formData.horarios_semana.forEach((dia, index) => {
                const diaNumero = (index + 1).toString() // 1=Domingo, 2=Segunda, ..., 7=Sábado
                hr_person_regras[diaNumero] = {
                    ini1: dia.ativo ? dia.inicio : "",
                    fim1: dia.ativo ? dia.fim : "",
                    ...(dia.ativo && dia.ini2 ? { ini2: dia.ini2 } : ''),
                    ...(dia.ativo && dia.fim2 ? { fim2: dia.fim2 } : '')
                }
            })

            finalData.hr_person_regras = JSON.stringify(hr_person_regras)
        }

        if (id) {
            finalData.id = id
        }

        sendWs('criarEditarAutorizacao', finalData)
    }

    const handleChangeMorador = (event) => {
        setFormData((prev) => ({
            ...prev,
            morador: event.target.value || prev.morador,
        cd_acesso_morador: event.target.cd_acesso || prev.cd_acesso_morador,
        id_imovel_morador: event.target.id_imovel_morador || prev.id_imovel_morador
        }))
    }

    const handleHorariosChange = (atualizacao) => {
        setFormData(prevFormData => {
            const novosHorarios = typeof atualizacao === 'function'
                ? atualizacao(prevFormData.horarios_semana)
                : atualizacao;

            return {
                ...prevFormData,
                horarios_semana: novosHorarios
            };
        });
    };

    return (
        <OneModal
            onClose={() => {
                setIdAutorizacao(null)
            }}
            open={openModal}
            setOpen={setOpenModal}
            titleText={id ? 'Editar Autorização' : 'Adicionar Autorização'}
            FooterButtons={FooterButtons}
        >
            {loading
                ? <CircularProgress />
                : (
                    <>
                        {id && !initialData.cd_acesso_morador
                            ? <Typography sx={{ color: 'red', fontSize: '16px', fontWeight: 'bold' }}>Erro ao buscar autorização</Typography>
                            : (<form id="autorizados-form" onSubmit={handleSubmit}>
                                <Grid container spacing={1}>
                                    <Grid item xs={12}>
                                        <Typography>*Morador</Typography>
                                    </Grid>
                                    <Grid item xs={12} >
                                        <AutocompletePessoa
                                            key={`${initialData?.morador || "0"}-${initialData?.cd_acesso_morador || "0"}`}
                                            callback={handleChangeMorador}
                                            optionsDefault={[{
                                                nome: initialData?.morador || '',
                                                cd_acesso: initialData?.cd_acesso_morador || '',
                                                imovel: initialData?.imovel || ''
                                            }]}
                                            getOptionLabel={(option) => {
                                                if (!option.nome && !option.imovel) {
                                                    return ""
                                                }
                                                return `${option.nome} - ${option.imovel}`
                                            }}
                                            defaultValue={{
                                                nome: initialData?.morador || '',
                                                cd_acesso: initialData?.cd_acesso_morador || '',
                                                imovel: initialData?.imovel || ''
                                            }}
                                            condominio={initialData?.id_central || formData?.id_central || ''}
                                            newSx={{ height: '45px', fontSize: '15px' }}
                                        />
                                    </Grid>
                                    <Grid item container xs={12} spacing={1} sx={{ marginTop: '5px' }}>
                                        <Grid item xs={6} sx={{ display: 'flex', alignItems: 'center', justifyContent: 'start' }} gap={2}>
                                            <Typography>*Data Inicial</Typography>
                                            <OneDatePicker
                                                name="dt_inicial"
                                                type="date"
                                                impedirPassado={true}
                                                defaultValue={initialData?.dt_inicial}
                                                callback={handleChange}
                                                newSx={{ height: '35px', width: '150px', fontSize: '15px' }}
                                            />
                                        </Grid>
                                        <Grid item xs={6} sx={{ display: 'flex', alignItems: 'center', justifyContent: 'start' }} gap={2}>
                                            <Typography>*Data Final</Typography>
                                            <OneDatePicker
                                                type="date"
                                                name="dt_final"
                                                defaultValue={initialData?.dt_final}
                                                callback={handleChange}
                                                impedirPassado={true}
                                                newSx={{ height: '35px', width: '150px', fontSize: '15px' }}
                                            />
                                        </Grid>
                                    </Grid>

                                    <Grid item container xs={12} spacing={1} sx={{ marginTop: '5px' }}>
                                        <Grid item xs={4} sx={{ display: 'flex', alignItems: 'center', justifyContent: 'start' }} gap={2}>
                                            <Typography>Notificar Morador</Typography>
                                            <OneSwitch
                                                name="notificar_morador"
                                                defaultValue={initialData.notificar_morador || ''}
                                                onChange={handleChangeSwitch}
                                            />
                                        </Grid>
                                        <Grid item xs={4} sx={{ display: 'flex', alignItems: 'center', justifyContent: 'start', visibility: 'hidden' }} gap={2}>
                                            <Typography>Pré-autorização</Typography>
                                            <OneSwitch
                                                name="pre_autorizacao"
                                                defaultValue={initialData.pre_autorizacao || ''}
                                                onChange={handleChangeSwitch}
                                                disabled
                                            />
                                        </Grid>
                                        <Grid item xs={4} sx={{ display: 'flex', alignItems: 'center', justifyContent: 'start' }} gap={2}>
                                            <Typography>Horarios personalizados</Typography>
                                            <OneSwitch
                                                name="personalizado"
                                                defaultValue={initialData.personalizado || ''}
                                                onChange={handleChangeSwitch}
                                            />
                                        </Grid>
                                    </Grid>

                                    <fieldset style={{ display: formData.personalizado ? 'flex' : 'none', border: '1px solid #ccc', borderRadius: '10px', padding: '5px', marginTop: '5px', width: '100%' }}>

                                        <Grid item container xs={12} >
                                            <Grid item xs={12}>
                                                <HorariosSemana
                                                    horarios={formData.horarios_semana || []}
                                                    setHorarios={handleHorariosChange}
                                                    setFormData={setFormData}
                                                />
                                            </Grid>
                                        </Grid>
                                    </fieldset>
                                </Grid>
                            </form>)}
                    </>
                )}
        </OneModal>
    )
}

export const FooterButtons = () => {
    return (
        <Grid container sx={{ alignItems: 'center', justifyContent: 'space-between', width: '100%' }}>
            <span style={{ fontSize: '13px', margin: 0, padding: 0 }}>* Campos obrigatórios!</span>
            <Button color="one_primary" variant="contained" form="autorizados-form" type="submit">Salvar</Button>
        </Grid>
    )
}

export default ModalAutorizados
